import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

var NoResultsCard = /*#__PURE__*/function (_React$Component) {
  function NoResultsCard() {
    _classCallCheck(this, NoResultsCard);

    return _callSuper(this, NoResultsCard, arguments);
  }

  _inherits(NoResultsCard, _React$Component);

  return _createClass(NoResultsCard, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "card no-results-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "card-header"
      }, this.props.message), this.props.buttons && this.props.buttons.length && /*#__PURE__*/React.createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row d-none d-sm-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, this.props.buttons.map(function (button, index) {
        var href = button.link && encodeURI(button.link);
        return /*#__PURE__*/React.createElement("a", {
          href: href,
          onClick: button.onClick,
          className: "btn btn-primary btn-lg",
          key: index
        }, button.label);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row d-block d-sm-none"
      }, this.props.buttons.map(function (button, index) {
        var href = button.link && encodeURI(button.link);
        return /*#__PURE__*/React.createElement("div", {
          className: "col-12",
          key: index
        }, /*#__PURE__*/React.createElement("a", {
          href: href,
          className: "btn btn-primary btn-block"
        }, button.label));
      })))));
    }
  }]);
}(React.Component);

_defineProperty(NoResultsCard, "propTypes", {
  message: PropTypes.string.isRequired,
  buttons: PropTypes.array
});

NoResultsCard.displayName = "NoResultsCard";
export { NoResultsCard };